import "./input-textarea.css";

const InputTextArea = ({ register, name, title, error, value, onChange }) => {
  const inputProps = register
    ? { ...register(name) }
    : { value: value ?? "", onChange };

  return (
    <div className="input-div">
      <textarea
        rows={10}
        className="input-form"
        autoComplete="none"
        placeholder=" "
        // {...register(name)}
        {...inputProps}
      />
      <label htmlFor={name} className="label-form">
        {title}
      </label>
      {error && <span className="fade-in">{error}</span>}
    </div>
  );
};

export default InputTextArea;
